define('views/microshop-shops-view',[
  'jquery',

  'modules/overlay-box',
  'modules/options-menu',
  'modules/order-matrix',

  'connections/offer-connection',
  'connections/product-connection',

  'utils/view',
  'utils/tooltip-init',
  'utils/pikaday-i18n',
  'utils/toast',

  'pikaday',
  'server-settings',
  'modules/pop-over',
  'connections/profile-connection'
], function (
  $,
  OverlayBox,
  OptionsMenu,
  OrderMatrix,
  OfferConnection,
  ProductConnection,
  View,
  tooltipInit,
  pikadayi18n,
  toast,
  Pikaday,
  settings,
  PopOver,
  ProfileConnection
) {
  var _this;
  var MicroshopShopsView = (function () {
    function MicroshopShopsView($container) {
      _this = this;
      _this.container = $container;
    }

    MicroshopShopsView.prototype.init = function () {
      _this.bindSearch();
      _this.initTooltips();
      _this.initDatePicker();

      $('.shopLink').on('click', function () {
        var shopUrl = $(this).closest("[data-url]").data('url');
        var shopOpen = $(this).closest("[data-openshop]").data('openshop');
        var shopEmail = $(this).closest("[data-useremail]").data('useremail');

        if (shopOpen.length > 0) {
          var $popupLoginUserTemplate = $('#microshop-login-user');
          var loginUserPopOver = new PopOver($(document), $popupLoginUserTemplate);
          loginUserPopOver.show($(this));
          $('[data-popup-login-open]').html(shopOpen);
          $('[data-popup-login-no]').off('click');
          $('[data-popup-login-no]').on('click', function () { loginUserPopOver.hide(); });
          $('[data-popup-login-yes]').off('click');
          $('[data-popup-login-yes]').on('click', function () {
            ProfileConnection.setActingRole(shopEmail).then(function () {
              window.location.href = shopUrl;
            });
          });
        }
        else {
          window.location.href = shopUrl;
        }
      });
    };

    MicroshopShopsView.prototype.initTooltips = function () {
      // Prevent binding on touch devices.
      if (!Modernizr.touch) tooltipInit(_this.container);
    };

    MicroshopShopsView.prototype.initDatePicker = function () {
      var fieldFrom = $('[data-from-date]')[0];
      var fieldTo = $('[data-to-date]')[0];

      var createPicker = function (field) {
        $(field).attr('autocomplete', 'off');
        return new Pikaday({
          field: field,
          firstDay: 1,
          i18n: pikadayi18n,
          toString: function (date) { return moment(date).format('YYYY-MM-DD'); },
          onSelect: function () { _this.updateDate(this, field); }
        });
      };
      createPicker(fieldFrom);
      createPicker(fieldTo);
    };

    MicroshopShopsView.prototype.updateDate = function (picker, input) {
      var pickerDate = picker.getDate();
      var date = moment(pickerDate).format('YYYY-MM-DD');
      $(input).val(date);
      $(input).closest("form").submit();
    };

    MicroshopShopsView.prototype.bindSearch = function () {
      $('[data-date-remove]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(e.target).prev('input').val('');
        $(e.target).closest("form").submit();
      });

      $('[data-order-by]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var val = $(e.target).data('orderBy');
        var orderEl = $('#orderBy');
        var descEl = $('#desc');
        var descElVal = descEl.val();
        descEl.val(val == orderEl.val() ? (descElVal == "True" ? "False" : "True") : descElVal);
        orderEl.val(val);
        orderEl.closest("form").submit();
      });

      $('#downloadAsCsv').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var csv = $('#csv');
        csv.val("True");
        csv.closest("form").submit();
        setTimeout(function () {
          csv.val("False");
        }, 100);
      });

    };
    return MicroshopShopsView;
  })();

  return View('MicroshopShopsView', function () {
    var view = new MicroshopShopsView($('[data-view="MicroshopShopsView"]'));
    view.init();
  });
});

